<template>
  <v-content class="content_body" id="passo-5">
    <div>
      <v-layout>
        <!-- Payments -->
        <div class="box-forma-pagamento">
          <h2 class="pt-0 pb-3 headers">Forma de Pagamento</h2>
          <v-form v-model="validPasso3" class="form-emitir">
            <div class="box-parcelas">
              <v-select
                label="Nº de parcelas"
                placeholder=" "
                v-model="calculator.parcelNumber"
                :items="disponibleParcels"
                :item-value="'index'"
                :item-text="'description'"
                @input="onSelectParcel()"
                class="jns-input input-parcelas"
                outlined
              ></v-select>

              <v-text-field
                label="1ª Parcelamento"
                placeholder=" "
                class="jns-input input-primeira-parcela"
                disabled
                :value="
                  calculator.first_parcel.toLocaleString(
                    'pt-BR',
                    $settings.moneyFormatOptions
                  )
                "
                :rules="rule"
                required
              ></v-text-field>
            </div>

            <div class="box-fracionamento">
              <v-text-field
                label="Adicional de Fracionamento (R$)"
                placeholder=" "
                class="jns-input input-adicional"
                disabled
                :value="
                  calculator.additional_fractionation.toLocaleString(
                    'pt-BR',
                    $settings.moneyFormatOptions
                  )
                "
                :rules="rule"
                required
              ></v-text-field>

              <v-select
                label="Dias"
                placeholder=" "
                class="jns-input input-dias"
                outlined
                v-model="calculator.paymentDay"
                :items="paymentDays"
                :item-value="'value'"
                :item-text="'text'"
                :selected="7"
                :rules="rule"
                required
              ></v-select
              >
            </div>
          </v-form>
          <v-flex v-if="recusada_por_limite" x8>
            <div class="msg_limites">
              <span
                >Tomador não possui mais Limite de Crédito para realizar a
                emissão desta Apólice.</span
              >
            </div>
          </v-flex>

          <div class="box-buttons">
            <v-btn
              class="jns-button width-auto white-button"
              @click="onDesist()"
              >Desistir</v-btn
            >
            <v-btn
              class="jns-button width-auto yellow-button"
              @click="onEmitirApolice()"
              :disabled="recusada_por_limite || !validPasso3"
            >
              Emitir apólice
              <v-icon>arrow_right_alt</v-icon>
            </v-btn>
          </div>
        </div>
        <!-- ./Payments -->
      </v-layout>
    </div>

    <v-dialog v-model="mensagemMaximoMinimo" :max-width="'640'">
      <base-modal>
        <h2 class="headline">Valor fora do permitido</h2>
        <br />
        <h3 v-if="this.slider.limitType == '$'">
          Valor deve estar entre
          {{ Crmin.toLocaleString("pt-BR", $settings.moneyFormatOptions) }} e
          {{ CrmaxLabel.toLocaleString("pt-BR", $settings.moneyFormatOptions) }}
        </h3>
        <h3 v-if="this.slider.limitType == '%'">
          Valor deve estar entre {{ parseFloat(Txmin).toFixed(3) }}% e
          {{ Txmax }}%
        </h3>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8>
            <button
              class="button jns-button yellow-button"
              @click="mensagemMaximoMinimo = false"
            >
              OK
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
  </v-content>
</template>

<script lang="js">
import { VMoney } from "v-money";
import axios from "axios";
import config from "@/../config";
export default {
  name: "PremioComissao",
  props: ["idProposta", "idProduto", "proposta"],
  data() {
    return {
      validPasso3: false,
      rule: [
        v => !!v || 'O Campo segurado é obrigatório.',
      ],
      //FIXME:Validar utilização para mascara
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: " ",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      isInputCommissionActive: false,
      development: true,
      moneyConfig: {},
      paymentDays: ["7"],
      showTooltipTax: false,
      showTooltipCommission: false,
      lock_icon: "lock_open",
      lock_icon_values: {
        open: "lock_open",
        close: "lock",
      },
      agravamento: false,
      slider: {
        dragger: 0,
        min: 0,
        max: 0,
        limit: 0,
        limitType: "$",
        color: "#282498",
        track_color: "gray",
        step: 1,
        original: 20,
        update: false,
      },
      //TODO: Remover todas as va
      calculator: {
        commission: 0,
        commissionPercentual: 0,
        appliedTax: 0,
        premium: 0,
        originalCommission: 0,
        originalCommissionTax: 0,
        originalCommissionPercentual: 0,
        originalAppliedTax: 0,
        originalPremium: 0,
        aggravation: 0,
        fixedAggravationCompare: 41,
        /* Payment values */
        parcelNumber: 0,
        additional_fractionation: 0,
        first_parcel: 0,
        paymentDay: 7,
      },
      parcels: [],
      disponibleParcels: [],
      fractionation: 0, // Fracionamento
      PARCEL_MIN_VAL: 1500,
      PREMIUM_PARCELLATION_CUT: 20000,
      relevant_serasa: false,
      isCommissionSeted: false,
      isInputTaxa: false,
      commissionMaximumLimit: 0,
      mensagemMaximoMinimo: false,
      recusada_por_limite: false,
      /*fixeMaxTax: 15,
      minTax: 15, //TODO: Setar valores
      maxTax: 41, //TODO: Setar valores,
      aggravationCommissionPercent: 0.5, //Agravamento em comissão percentual,
      aggravationTax: 0.1, // Agravamento na taxa,
      maxCommissionPercent: 41, // Comissao do corretor maxima
      commissionPercentTemp: 15, // Valor temporario para o caso do cadeado
      minPremium: 160, //Premio minimo aceito pela i4pro*/

      /* Payment values */
      parcelNumber: 0,
      additional_fractionation: 0,
      first_parcel: 0,
      paymentDay: 7,

      /* Variveis de cálculos */
      Po: 0, //Premio original
      Txo: 0, //Taxa original
      Cro: 0, //Comissão em reais
      Cco: 0, // Comissão corretor ou percentual de commissão
      cct: 15, //Valor temporario para o caso do cadeado
      Pmin: 160, //Premio minimo aceito pela i4pro
      Txmax: 15, //Valor minimo e maximo da taxa em relacao ao slider
      Txmin: 0, //No caso de Txmin tem que calcular o termo Po - Cro e verificar se  Po - Cro >= Pmin
      atx: 0.1, //Agravamento em tx,
      acc: 0.5, //Agravamento em cc,
      Ccmax: 41, //Comissao do corretor maxima
      Cr: 0, //Comissão
      P: 0, // Prêmio
      Tx: 0, // Taxa
      Cc: 0, // % comissão
      So: 20, // Quando o slider estiver em 20% os valores terao quer ser os originais
      A: 0, //Fator que e combinacao de acc e atx
      Crmax: 0, // Comissão máxima
      Crmin: 0, // Comissão minima
      Crminlabel: 0,
      permissao_alterar_portal: true,
      CrmaxLabel: "",
      casas_decimais: 4,
      Ccmin: 1, // Percentual de comissão do correto minimo
    };
  },
  directives: { money: VMoney },
  computed: {
    commissionFormatted: {
      get: function () {
        if (this.isInputCommissionActive) {
          return this.Cr.toString();
        } else {
          let commission = this.Cr.toString().replace(",", ".");

          return parseFloat(commission).toLocaleString(
            "pt-BR",
            this.$settings.moneyFormatOptions
          );
        }
      },
      set: function (newValue) {
        let commission = newValue
          .toString()
          .replace(",", ".")
          .replace(/[^0-9\.]/g, "")
          .replace("R$", "");

        this.Cr = Number(commission);
      },
    },
    lengthSliderLimit() {
      if (this.slider.limitType == "%") {
        let dashedLimit = 9.18564;
        return `width:${dashedLimit}%`;
      } else {
        let dashedLimit = 9.18564;
        return `width:${dashedLimit}%`;
      }
    },
    taxaFormatada: {
      get: function () {
        if (this.isInputTaxa) {
          let taxa = this.Tx.toString().replace(",", ".");
          return this.formatValue(taxa);
        } else {
          return this.formatValue(this.Tx);
        }
      },
      set: function (newValue) {
        this.Tx = newValue;
      },
    },
    percentualComissaoFormatada: {
      get: function () {
        return this.formatValue(this.Cc);
      },
      set: function (newValue) {
        this.Cc = newValue;
      },
    },
  },
  methods: {
    /* Initializes */
    definePaymentDays() {
      this.paymentDays = [];
      let initial = this.proposta.dia_minimo_vencimento;
      let limit =  this.proposta.dia_maximo_vencimento;

      for (let index = initial; index <= limit; index++) {
        this.paymentDays.push({ text: index.toString(), value: index });
      }
    },
    defineOriginalValues() {
      if (this.proposta) {
        try {
          this.Cco = this.proposta.comissao_percentual_passo5;
          this.Cc = this.Cco;
          this.cct = this.Cco;
          this.Cro = this.proposta.comissao_reais_passo5;
          this.Cr = this.Cro;
          this.Txo = this.proposta.taxa_passo5;
          this.Tx = this.Txo;
          this.Po = this.proposta.premio_passo5;
          this.P = this.Po;
          this.Pmin = this.proposta.premio_minimo_passo5;

          this.agravamento = this.proposta.agravamento_passo5;
          if (this.agravamento == false)
            this.lock_icon = this.lock_icon_values.close;

          this.permissao_alterar_portal = this.proposta.permissao_alterar_portal;
          this.relevant_serasa = this.proposta.tomador_serasa_relevante;

          this.recusada_por_limite = this.proposta.recusada_por_limite;
        } catch (error) {}
      }
    },
    defineCommissionSliderValues() {
      this.slider.limitType = "$";
      this.slider.min = 0;
      this.slider.max = 100;
      this.slider.limit = this.calculateLimit();
      this.slider.update = true;
      this.slider.dragger = 20;
      this.calcularFatorCombinacao();
      this.calcularComisaoMaxima();
      this.calcularComissaoMinima();
      this.calcularComissaoMaximaLabel();
    },
    defineParcels() {
      if (this.proposta.produto_parcelamentos != null) {
        this.parcels = [];
        let index = 0;
        this.proposta.produto_parcelamentos.forEach((item) => {
          let parcel = {
            index: index,
            parcelId: item.id_produto_parcela,
            description: item.descricao,
            parcelNumbers: item.numero_parcelas,
            interests: item.juros,
          };
          this.parcels.push(parcel);
        });

        this.parcels.sort(function (a, b) {
          return a.parcelNumbers - b.parcelNumbers;
        });
      }
    },
    defineCommissionMaxValue() {
      this.commissionMaximumLimit = 0;

      let maximumValue =
        (this.calculator.originalPremium * 41) /
        this.calculator.originalAppliedTax;

      this.commissionMaximumLimit = (maximumValue * this.fixeMaxTax) / 100;
    },

    /* Emiters */
    emitProposalValues() {
      if (this.calculator.parcelNumber == null) return null;

      let selectedParcel = this.parcels.find(
        (p) => p.index == this.calculator.parcelNumber
      );
      if (selectedParcel) {
        let proposalParcels = [
          {
            id_parcelamento: selectedParcel.parcelId,
            premio_total: Number(this.P),
            nr_parcela: selectedParcel.parcelNumbers,
            qt_total: Number(selectedParcel.value),
            vl_adicional:
              this.calculator.additional_fractionation /
              Number(selectedParcel.parcelNumbers),
          },
        ];

        let proposalCoverages = [];
        if (this.proposta.coberturas.length == 1) {
          let coverage = this.proposta.coberturas[0];
          proposalCoverages = [
            {
              id: Number(coverage.id),
              premio: Number(this.P),
            },
          ];
        } else {
          let sum = this.proposta.coberturas.reduce(
            (a, b) => a + (b["premio"] || 0),
            0
          );

          this.proposta.coberturas.forEach((coverage) => {
            let percent = (coverage.premio * 100) / sum;
            let premium = (this.P * percent) / 100;

            proposalCoverages.push({
              id: Number(coverage.id),
              premio: Number(premium),
            });
          });
        }

        const postData = {
          id_proposta: Number(this.idProposta),
          id_produto: Number(this.idProduto),
          taxa_risco: this.Tx,
          comissao_corretor: this.Cc,
          quantidade_parcelas: Number(selectedParcel.parcelNumbers),
          dias_primeira_parcela: Number(this.calculator.paymentDay),
          comissao_reais: this.Cr,
          agravamento: this.agravamento,
          coberturas: proposalCoverages,
          parcelamento: proposalParcels,
        };

        this.$emit("emitProposalValues", postData);
      }
    },

    /* Utils */
    formatValue(value) {
      try {
        return parseFloat(Number(value).toFixed(this.casas_decimais));
      } catch (error) {
        return 0;
      }
    },

    /* Parcels */
    calculateAdditionalFractionation(premium, interests, parcelNumbers) {
      if (parcelNumbers == 1) return 0;

      if (premium == null) premium = 0;

      if (interests == null) interests = 0;

      if (parcelNumbers == null) parcelNumbers = 0;

      try {
        let x = (1 + parseFloat(interests)) ** (parseFloat(parcelNumbers) - 1);
        let numerator =
          parseFloat(premium) * parseFloat(interests) * parseFloat(x);
        let denominator =
          parseFloat(x) - 1 + parseFloat(interests) * parseFloat(x);
        let division = parseFloat(numerator) / parseFloat(denominator);

        return (
          parseFloat(division) * parseFloat(parcelNumbers) - parseFloat(premium)
        );
      } catch (error) {
        console.error(
          "Não foi possível calcular o adicional de fracionamento. erro: " +
            error
        );
        return 0;
      }
    },
    calculateParcelValues() {
      this.disponibleParcels = [];

      if (this.relevant_serasa) {
        let parcel = this.parcels[0];
        this.setParcelValues(0);
        parcel.index = 0;
        parcel.additional_fractionation = 0;
        parcel.value = this.P;
        this.calculator.first_parcel = parcel.value;
        this.disponibleParcels.push(parcel);
        return;
      }

      for (let i = 0; i < this.parcels.length; i++) {
        try {
          let parcel = this.parcels[i];
          let parcelNumbers = parcel.parcelNumbers;
          let interests = parseFloat(parcel.interests) / 100;
          let additional_fractionation = 0;
          if (interests > 0) {
            additional_fractionation = this.calculateAdditionalFractionation(
              this.P,
              interests,
              parcelNumbers
            );
          }

          let parcelValue =
            parseFloat(this.P + additional_fractionation) / parcelNumbers;

          let additional_fractionation_parcel =
            parseFloat(additional_fractionation) / parcelNumbers;

          let totalPremiun =
            parseFloat(this.P) + parseFloat(additional_fractionation);

          if (parcelNumbers >= 2) {
            if (parcelValue < this.PARCEL_MIN_VAL) continue;
          }

          if (parcelNumbers >= 4) {
            if (
              parseFloat(this.P) < parseFloat(this.PREMIUM_PARCELLATION_CUT) &&
              interests == 0
            )
              continue;
          }

          parcel.index = i;
          parcel.additional_fractionation = additional_fractionation;
          parcel.value = parcelValue;
          this.disponibleParcels.push(parcel);
        } catch (error) {
          console.error("Erro ao calcular as parcelas. Erro: " + error);
        }
      } // ./ End For
      this.calculator.parcelNumber = 0;
      this.setParcelValues(0);
    },
    setParcelValues(parcelNumber) {
      let selectedParcel = this.parcels.find((p) => p.index == parcelNumber);
      if (selectedParcel) {
        this.calculator.additional_fractionation =
          selectedParcel.additional_fractionation != null
            ? selectedParcel.additional_fractionation
            : 0;
        this.calculator.first_parcel =
          selectedParcel.value != null ? selectedParcel.value : 0;
      }
    },

    /* Screen events */
    onLock() {
      if (this.agravamento) {
        if (this.lock_icon_values.open == this.lock_icon) {
          // Aberto
          this.lock_icon = this.lock_icon_values.close;

          //FIXME: Rever este calculo
          //this.Cr = (this.Txmax / this.Txo) * this.Po * this.cct / 100;
        } else {
          // Fechado
          this.lock_icon = this.lock_icon_values.open;
          this.Crmax =
            ((this.Txmax * this.Cco +
              this.A * this.Txmax ** 2 -
              this.A * this.Txmax * this.Txo) *
              this.Cro) /
            (this.Txo * this.Cco);
        }

        this.calcularComissaoMaximaLabel();
      } else {
        this.lock_icon = this.lock_icon_values.close;
      }
    },
    onUsingCommission() {
      this.defineOriginalValues();
      this.defineCommissionSliderValues();
      this.slider.step = 0.5;
      this.slider.limitType = "$";
      if (this.agravamento) this.lock_icon = this.lock_icon_values.open;
      this.calculateParcelValues();
    },
    onUsingTax() {
      this.defineOriginalValues();
      this.slider.min = 0;
      this.slider.max = 100;
      this.slider.limit = this.calculator.originalAppliedTax;
      this.slider.update = true;
      this.slider.dragger = 20; // Inicia em 20%

      this.slider.limitType = "%";
      this.slider.step = 0.5;
      this.calculateParcelValues();
      this.calcularTaxaMinima();
      if (this.agravamento) this.lock_icon = this.lock_icon_values.open;
    },
    onSelectParcel() {
      this.setParcelValues(this.calculator.parcelNumber);
    },
    onSpecialRequest() {
      this.$emit("showQuestionamento");
    },
    onDesist() {
      this.$emit("desistir");
    },
    onEmitirApolice() {
      this.emitProposalValues();
      this.$emit("abrirModalTermosAceite");
    },

    /* Calculators */

    calculateLimit() {
      if (this.slider.limitType == "$") {
        return this.calculator.originalCommission;
      } else {
        return this.calculator.originalAppliedTax;
      }
    },

    calcularTaxaMinima() {
      // No caso de Txmin tem que calcular o termo Po - Cro e verificar se  Po - Cro >= Pmin
      this.Txmin = ((this.Po - this.Cro) / this.Po) * this.Txo;
      if (this.Po - this.Cro < this.Pmin)
        this.Txmin = (this.Pmin / this.Po) * this.Txo;
    },

    calcularComisaoMaxima() {
      //# Calculando o valor de Crmax para o cadeado aberto
      this.Crmax =
        ((this.Txmax * this.Cco +
          this.A * this.Txmax ** 2 -
          this.A * this.Txmax * this.Txo) *
          this.Cro) /
        (this.Txo * this.Cco);
    },

    calcularComissaoMinima() {
      //# No caso de Crmin tem que calcular o termo Po - Cro e verificar se  Po - Cro >= Pmin
      this.Crmin = 0;
      if (this.Po - this.Cro < this.Pmin)
        this.Crmin = this.Cro - (this.Po - this.Pmin);

      this.Crminlabel = this.Crmin;
      if (this.Crmin == 0) {
        this.calcularTaxaMinima();
        this.Crminlabel =
          ((this.Txmin / this.Txo) * this.Po * this.Ccmin) / 100;
      }
    },

    calcularComissaoMaximaLabel() {
      if (this.lock_icon == this.lock_icon_values.close) {
        this.CrmaxLabel = ((this.Txmax / this.Txo) * this.Po * this.cct) / 100;
      } else {
        this.CrmaxLabel =
          ((this.Txmax / this.Txo) * this.Po * this.Ccmax) / 100;
      }
    },

    calcularFatorCombinacao() {
      //# Fator que e combinacao de acc e atx
      this.A = this.acc / this.atx;
    },

    /* Using tax */
    atualiza_valores_taxa(taxa) {
      // Metodo que atualiza os valores
      //Premio so depende da taxa
      let premio = this.calcula_premio(taxa);
      let comissao_corretor = 0,
        comissao_reais = 0;
      //Calculando os valores para a regiao acima do original
      if (taxa >= this.Txo) {
        comissao_corretor = this.calcula_comissao_corretor(taxa);
        comissao_reais = (premio * comissao_corretor) / 100;
      } else {
        comissao_reais = this.Po * (taxa / this.Txo) - (this.Po - this.Cro);
        comissao_corretor = (100 * comissao_reais) / premio;
        if (comissao_corretor < this.Ccmin) {
          comissao_corretor = this.Ccmin;

          comissao_reais = (premio * comissao_corretor) / 100;
        }
      }

      this.atualiza_valores_na_tela(
        taxa,
        premio,
        comissao_reais,
        comissao_corretor
      );
    },
    // Using commission
    atualiza_valores_comissao(comissao) {
      //   """ Metodo que atualiza os valores """

      //# Premio so depende da taxa
      let premio = 0;
      let taxa = 0;
      let comissao_corretor = 0;
      let comissao_reais = 0;

      premio = this.calcula_premio_comissao(comissao);
      taxa = this.calcula_taxa_comissao(comissao);

      //# Calculando os valores para a regiao acima do original
      if (comissao >= this.Cro) {
        //calcula os valores do comissao do corretor e comissao em reais acima do original
        comissao_corretor = this.calcula_comissao_corretor(taxa);
        //# A comissao em reais depende do premio e da comissao do corretor
        comissao_reais = (premio * comissao_corretor) / 100;
      } else {
        //calcula os valores do comissao do corretor e comissao em reais abaixo do original
        // # Como nao tem agravamento para valores abaixo do original e foi utilizado Po = ((Po - Cro) / Po) * Txo
        //# para passar pelo minimo entao Cr = (Tx / Txo) * Po - (Po - Cro)
        comissao_reais = comissao;
        taxa = ((comissao + (this.Po - this.Cro)) / this.Po) * this.Txo;
        premio = (taxa / this.Txo) * this.Po;
        comissao_corretor = (100 * comissao_reais) / premio;
        if (comissao_corretor < this.Ccmin) {
          this.calcularTaxaMinima();
          premio = (this.Txmin / this.Txo) * this.Po;
          comissao_corretor = this.Ccmin;
          comissao_reais = (premio * comissao_corretor) / 100;
        }
      }

      this.atualiza_valores_na_tela(
        taxa,
        premio,
        comissao_reais,
        comissao_corretor
      );
    },
    calcula_premio(taxa) {
      //""" Metodo que calcula o premio """
      return (taxa / this.Txo) * this.Po;
    },

    calcula_comissao_corretor(taxa) {
      //""" Metodo que calcula a comissao do corretor com agravamento """

      //# Se o cadeado estiver aberto entao agravar a comissao do corretor
      let agravamento = 0;
      if (this.lock_icon == "lock_open") agravamento = taxa - this.Txo;

      let cc = this.Cco + (this.acc * agravamento) / this.atx;

      //# Verificando se a comissao agravada superou o maximo permitido
      if (cc > this.Ccmax) cc = this.Ccmax;

      if (this.lock_icon == "lock_open") this.cct = cc;

      return this.cct;
    },
    calcula_premio_comissao(comissao) {
      //""" Metodo que calcula o premio """

      //# Necessario calcular a taxa a partir da comissao
      let a = this.A;
      let b = this.Cco - this.A * this.Txo;
      let c = -(comissao * this.Txo * this.Cco) / this.Cro;
      //# Bhaskara usando apenas a raiz positiva
      let taxa = -b / (2 * a) + Math.sqrt(b ** 2 - 4 * a * c) / (2 * a);

      return (taxa / this.Txo) * this.Po;
    },
    calcula_taxa_comissao(comissao) {
      //# Necessario calcular a taxa a partir da comissao
      let a = this.A;
      let b = this.Cco - this.A * this.Txo;
      let c = -(comissao * this.Txo * this.Cco) / this.Cro;
      //# Bhaskara usando apenas a raiz positiva
      let taxa = -b / (2 * a) + Math.sqrt(b ** 2 - 4 * a * c) / (2 * a);
      return taxa;
    },

    slider_to_taxa(slider_valor) {
      /*Metodo que calcula o valor da taxa a partir do slider*/

      // Valor do slider
      let s = parseFloat(slider_valor);
      let taxa = 0;

      //Fazendo um ajuste linear para manter a proporcao 0-So e So-100
      //Convertendo o valor do slider para a taxa quando este <= So
      if (s <= this.So)
        taxa =
          this.Txmin +
          (s - this.slider.min) *
            ((this.Txo - this.Txmin) / (this.So - this.slider.min));
      else
        taxa =
          this.Txo +
          (s - this.So) *
            ((this.Txmax - this.Txo) / (this.slider.max - this.So));

      return taxa;
    },

    taxa_to_slider(taxa) {
      //""" Metodo que calcula o valor do slider a partir da taxa"""
      let s = 0;
      if (taxa <= this.Txo) {
        s =
          ((taxa - this.Txmin) * (this.So - this.slider.min)) /
            (this.Txo - this.Txmin) +
          this.slider.min;
      } else {
        s =
          ((taxa - this.Txo) * (this.slider.max - this.So)) /
            (this.Txmax - this.Txo) +
          this.So;
      }

      return s;
    },

    slider_to_comissao(slider_valor) {
      //""" Metodo que calcula o valor da comissao a partir do slider """

      //# Valor do slider
      let s = parseFloat(slider_valor);
      let comissao = 0;
      //# Fazendo um ajuste linear para manter a proporcao 0-So e So-100
      //# Convertendo o valor do slider para a comissao quando este <= So
      if (s <= this.So) {
        comissao =
          this.Crmin +
          (s - this.slider.min) *
            ((this.Cro - this.Crmin) / (this.So - this.slider.min));
      } else {
        comissao =
          this.Cro +
          (s - this.So) *
            ((this.Crmax - this.Cro) / (this.slider.max - this.So));
      }
      return comissao;
    },

    comissao_to_slider(comissao) {
      //""" Metodo que calcula o valor do slider a partir da comissao"""
      let s = 0;
      if (comissao <= this.Cro) {
        s =
          ((comissao - this.Crmin) * (this.So - this.slider.min)) /
            (this.Cro - this.Crmin) +
          this.slider.min;
      } else {
        s =
          ((comissao - this.Cro) * (this.slider.max - this.So)) /
            (this.Crmax - this.Cro) +
          this.So;
      }
      return s;
    },

    /* Update screen fields */
    atualiza_valores_na_tela(taxa, premio, comissao_reais, comissao_corretor) {
      // Atualiza os valores da tela
      this.P = premio;
      this.Tx = taxa;
      this.Cr = comissao_reais;
      this.Cc = comissao_corretor;
      this.commissionFormatted = this.Cr;
    },

    atualiza_valores_pelo_campo_da_taxa() {
      // Metodo que atualiza os valores da simulacao pelo campo da taxa
      try {
        let taxa = parseFloat(this.Tx);
        if (
          parseFloat(Number(taxa).toFixed(6)) >=
            parseFloat(Number(this.Txmin).toFixed(6)) &&
          parseFloat(Number(taxa).toFixed(6)) <=
            parseFloat(Number(this.Txmax).toFixed(6))
        ) {
          let s = this.taxa_to_slider(taxa);
          this.slider.update = false;
          this.slider.dragger = s;

          this.atualiza_valores_taxa(taxa);

          this.calculateParcelValues();
        } else {
          this.mensagemMaximoMinimo = true;
        }
      } catch (error) {}
    },

    atualiza_valores_pelo_campo_da_comissao() {
      //""" Metodo que atualiza os valores da simulacao pelo campo da comissao """
      try {
        let comissao = parseFloat(this.Cr); // Comissão digitada
        let taxa = 0;
        if (this.lock_icon == "lock_open") {
          let a = this.A;
          let b = this.Cco - a * this.Txo;
          let c = (-100 * comissao * this.Txo) / this.Po;
          let taxa1 = -b / (2 * a) + Math.sqrt(b ** 2 - 4 * a * c) / (2 * a);
          let taxa2 = (100 * comissao * this.Txo) / (this.Po * this.Ccmax);
          taxa = Math.max(taxa1, taxa2);
        } else {
          taxa = (100 * comissao * this.Txo) / (this.Po * this.cct);
        }

        let premio = (taxa / this.Txo) * this.Po;
        let agravamento = taxa - this.Txo;
        let cc = this.Cco + (this.acc * agravamento) / this.atx;
        // if (cc < this.Ccmin) {
        //   cc = this.Ccmin;
        // }
        let comissao_corrigida = (premio * cc) / 100;

        if (
          parseFloat(comissao_corrigida).toFixed(3) >= this.Crmin &&
          parseFloat(comissao_corrigida).toFixed(3) <= this.Crmax
        ) {
          let s = this.comissao_to_slider(comissao_corrigida);
          this.slider.update = false;
          this.slider.dragger = s;
          this.atualiza_valores_comissao(comissao_corrigida);
        } else {
          this.mensagemMaximoMinimo = true;
        }
      } catch (error) {}
      this.calculateParcelValues();
    },

    /* Move the slider */

    // when moving slider calculate values
    atualiza_valores_pelo_slider() {
      if (this.slider.update) {
        let valor = this.slider.dragger;

        // Metodo que atualiza os valores da simulacao pelo slider

        // by tax
        if (this.slider.limitType == "%") {
          //Calculando o valor da taxa a partir do slider
          let taxa = this.slider_to_taxa(valor);
          this.atualiza_valores_taxa(taxa);
        } else {
          // Calculando o valor da comissão a partir do slider
          let comissao = this.slider_to_comissao(valor);
          this.atualiza_valores_comissao(comissao);
        }

        //Recalcular parcelas e emitir valores para proposta
        this.calculateParcelValues();
      }

      this.slider.update = true;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.defineOriginalValues();
    this.defineCommissionSliderValues();
    this.definePaymentDays();
    this.defineParcels();
    this.calculateParcelValues();
    this.moneyConfig = this.$settings.moneyConfig;
    this.$forceUpdate();
  },
};
</script>

<style lang='scss' scoped>
#jns {
  $blueColor: #282498;
  $whiteColor: #ffffff;

  .box-forma-pagamento {
    display: flex;
    flex-direction: column;
    width: 100%;

    .box-parcelas {
      display: flex;

      .input-parcelas,
      .input-primeira-parcela {
        width: 48%;
      }

      .input-primeira-parcela {
        margin-left: 4%;
      }
    }

    .box-fracionamento {
      display: flex;

      .input-adicional,
      .input-dias {
        width: 48%;
      }

      .input-dias {
        margin-left: 4%;
      }
    }

    .box-buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      background-color: #f5f5f5;
      position: fixed;
      bottom: 0;
      left: 0;
      width: calc(100vw - 30%);
      padding: 16px 32px;
    }

    @media screen and (max-width: 830px) {
      .box-parcelas {
        flex-direction: column;

        .input-parcelas,
        .input-primeira-parcela {
          width: 100%;
          margin: 2% 0;
        }
      }

      .box-fracionamento {
        flex-direction: column;

        .input-adicional,
        .input-dias {
          width: 100%;
          margin: 2% 0;
        }
      }
    }

    @media screen and (max-width: calc(1060px)) {
      .box-buttons {
        position: static;
        width: 100%;
        background: transparent;
      }
    }

        @media screen and (max-width: calc(610px)) {
      .box-buttons {
        flex-direction: column;
        padding: 0;

        .jns-button{
          width: 100%;
        }
      }
    }

    
  }

  .border-right {
    border-left: #ddd 2px solid;
    height: 360px;
    margin-left: 2%;
    flex-basis: 2%;
  }

  .headers {
    text-align: center;
    color: $blueColor;
  }

  .jns-button-color {
    background-color: $blueColor;
  }

  .button_nonactive {
    background-color: $whiteColor;
    color: $blueColor;
  }

  .v-icon {
    font-size: 20px !important;
  }

  .icon_blue {
    color: $blueColor;
    cursor: help;
  }

  .msg-tax {
    width: 42%;
    background-color: $whiteColor;
    color: black;
    position: absolute;
    border-radius: 4px;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    left: 40%;
    top: 8%;
    font-size: 13px;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;
    }
  }

  .msg-commission {
    width: 50%;
    background-color: $whiteColor;
    color: black;
    position: absolute;
    border-radius: 4px;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    left: 40%;
    top: 0%;
    font-size: 13px;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;
    }
  }

  .hint {
    float: right;
    margin-top: -16px;
    font-size: 10px;
  }

  .v-responsive {
    flex: inherit !important;
  }

  /* Slider */

  .slider {
    height: 100px;
    width: 99%;
    padding-left: 3%;
    padding-top: 50px;
    padding-bottom: 80px;
  }

  .left_ticks {
    height: 25px;
    border-left: 5px dashed red;
    border-bottom: 5px dashed red;
    margin-top: 9px;
    position: absolute;
  }

  .right_ticks[data-v-050ac8bc] {
    height: 22px;
    border-right: 2px solid #b6b6b6;
    float: right;
    margin-top: 11px;
  }

  .left_label {
    position: absolute;
    left: 10px;
    float: left;
    top: 372px;
  }

  .left_label_commission {
    position: absolute;
    text-align: left;
    left: 120px;
    font-size: 13px;
    color: gray;
    top: 372px;
  }

  .center_label_commission {
    position: absolute;
    text-align: left;
    left: 27%;
    font-size: 13px;
    color: #282498;
    font-weight: bold;
    top: 372px;
  }

  .right_label {
    position: absolute;
    text-align: center;
    left: 43%;
    font-size: 13px;
    top: 372px;
  }

  .read_only {
    background-color: #e6e6e6;
    height: 45px;
    padding-top: 0px;
    margin-top: 16px;
    padding-bottom: 10px;
    margin-bottom: 20px;
    font-weight: bold;
  }

  .msg_limites {
    background-color: #d21a5e;
    border-radius: 10px;
    padding: 12px;
    color: white;
    font-weight: bold;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/router/views/Propostas/Passos/PremioComissao.vue